@defer (when value()) {
  <app-contract-form
    [edit]="false"
    [create]="false"
    [delete]="false"
    [details]="true"
    [id]="id"
    [(value)]="value"
    [access]="access()"
  ></app-contract-form>
}
